import React, { useContext } from "react";
import { Table } from "antd";
import TableCard from "../../../../../../components/TableCard";
import TablePagination from "../../../../../../components/TablePagination";
import TableDicaHint from "../../../../../../components/TableDicaHint";
import { ThemeContext } from "../../../../../../contexts/ThemeContext";
import { IGiveawayAutoWithDetails } from "../../../../../../interfaces";

interface IProps {
    tableData: Array<any>;
    columns: any[];
    isLoading: boolean;
    pagination: { current: number; pageSize: number };
    setPagination: React.Dispatch<React.SetStateAction<{ current: number; pageSize: number }>>;
    onSelectGiveaway: (giveaway: IGiveawayAutoWithDetails) => void;
}

export default function TabTicketsAuto({
    tableData,
    columns,
    isLoading,
    pagination,
    setPagination,
    onSelectGiveaway,
}: IProps) {
    const { theme } = useContext<any>(ThemeContext);
    const isDark = theme === "dark";

    return (
        <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
            <TableDicaHint text="Dê um clique na linha ou no botão de ação para visualizar os bilhetes concorrendo neste sorteio." />

            {tableData.length > 10 && (
                <TablePagination
                    current={pagination.current}
                    pageSize={pagination.pageSize}
                    total={tableData.length}
                    itemName="sorteios"
                    pageSizeOptions={["10", "25", "50", "100"]}
                    onChange={(page: number, pageSize: number) => setPagination({ current: page, pageSize })}
                />
            )}

            <TableCard>
                <Table
                    rowKey="id"
                    size="middle"
                    className={`modern-data-table ${isDark ? "modern-data-table-dark" : ""}`}
                    columns={columns}
                    dataSource={tableData}
                    loading={isLoading}
                    scroll={{ x: "max-content" }}
                    pagination={
                        tableData.length > 10
                            ? {
                                  current: pagination.current,
                                  pageSize: pagination.pageSize,
                                  position: [],
                              }
                            : false
                    }
                    onRow={(record: any) => ({
                        onClick: () => onSelectGiveaway(record),
                        style: {
                            cursor: "pointer",
                        },
                    })}
                />
            </TableCard>

            {tableData.length > 10 && (
                <TablePagination
                    current={pagination.current}
                    pageSize={pagination.pageSize}
                    total={tableData.length}
                    itemName="sorteios"
                    pageSizeOptions={["10", "25", "50", "100"]}
                    onChange={(page: number, pageSize: number) => setPagination({ current: page, pageSize })}
                />
            )}
        </div>
    );
}
